import env from '@/env';
import identityApiClient from '@/services/identity';

class IdentityUsers {
  updateUserPassword = async (currentPassword: string, password: string) => {
    const response = await identityApiClient.put(`users/passwords`, {
      newPassword: password,
      currentPassword,
      clientId: env.api.clientKey,
      clientSecret: env.api.clientSecret,
    });
    return response.data;
  };
}

export const IdentityUsersInstance = new IdentityUsers();
